<template>
  <div class="home">
    <div class="Header">
      <Header  v-if="$route.meta.alive"></Header>
    </div>
    <div class="Main">
      <Main></Main>
    </div>
    <div class="Footer">
      <Footer  v-if="$route.meta.alive"></Footer>
    </div>
  </div>
</template>

<script>
import Header from "@/components/pc/Header";
import Main from "@/components/pc/Main";
import Footer from "@/components/pc/Footer";
export default {
  components: {
    Header: Header,
    Main: Main,
    Footer: Footer,
  },
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<style scoped lang="less">
/deep/.el-message{
  z-index: 99999999999;
  background-color:#fff !important;
  /* 设置文本颜色为白色 */
  position: absolute;
  color: white !important;
  /* 其他样式调整，根据需要自行添加 */
}
.el-menu--horizontal .el-menu {
  background-color: #fff !important;
}
body {
  text-align: center;
  background: #fdfdfd;
}

.home {
  margin: 0 auto;
  background: #fdfdfd;
  border-radius: 0px 0px 0px 0px;
  // min-height: 1937px;
  background: #13161B;
}
.Header {
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
}
.Main {
  width: 100%;
  background-color: #fdfdfd;
}
.Footer {
  width: 100%;
  background: #141414;
}
</style>
